/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".right[_ngcontent-%COMP%]{text-align:right}.header[_ngcontent-%COMP%]{font-size:16px;margin-bottom:10px;color:#9da2bd}.text[_ngcontent-%COMP%]{font-size:12px;color:#1a3349}"];
export { styles as styles };
